import styled, { createGlobalStyle, css } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { includes, mapValues, pick, toArray } from 'lodash';
import { Menu as Menu$1, Button as Button$2, Checkbox as Checkbox$1, Select as Select$2, TreeSelect as TreeSelect$2 } from 'antd2';
export { Tooltip } from 'antd2';
import React, { useRef, useCallback, createElement as createElement$1, cloneElement } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import classNames from 'classnames';
import 'react-intl-tel-input/dist/main.css';
import country from 'country-list-js';
import ReactIntlTelInput from 'react-intl-tel-input';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$b =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$b = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$a = fails$b;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$a(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$9 = fails$b;
var classof$3 = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$9(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$3(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$3 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var isObject$5 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$4 = isObject$5;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$4(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$4(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$4(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$4(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$a = global$b;
var isObject$3 = isObject$5;

var document$1 = global$a.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$3(document$1) && isObject$3(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var DESCRIPTORS$6 = descriptors;
var fails$8 = fails$b;
var createElement = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$6 && !fails$8(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$5 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPrimitive$1 = toPrimitive$2;
var has$6 = has$7;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$6(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$2 = isObject$5;

var anObject$6 = function (it) {
  if (!isObject$2(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$5 = anObject$6;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$5(O);
  P = toPrimitive(P, true);
  anObject$5(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$5 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$2 = {exports: {}};

var global$9 = global$b;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$4(global$9, key, value);
  } catch (error) {
    global$9[key] = value;
  } return value;
};

var global$8 = global$b;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$8[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$2.inspectSource;

var global$7 = global$b;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$7.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

var shared$2 = {exports: {}};

var store$1 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared$1 = shared$2.exports;
var uid$1 = uid$2;

var keys = shared$1('keys');

var sharedKey$2 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$6 = global$b;
var isObject$1 = isObject$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var objectHas = has$7;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;

var WeakMap = global$6.WeakMap;
var set, get, has$5;

var enforce = function (it) {
  return has$5(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$5 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$5 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$5,
  enforce: enforce,
  getterFor: getterFor
};

var global$5 = global$b;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var has$4 = has$7;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$2.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$4(value, 'name')) createNonEnumerableProperty$2(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$5) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$2(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});

var global$4 = global$b;

var path$1 = global$4;

var path = path$1;
var global$3 = global$b;

var aFunction$2 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$2(path[namespace]) || aFunction$2(global$3[namespace])
    : path[namespace] && path[namespace][method] || global$3[namespace] && global$3[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$6 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$2 : ceil)(argument);
};

var toInteger$5 = toInteger$6;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$2(toInteger$5(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$4 = toInteger$6;

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$4(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toLength$2 = toLength$3;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength$2(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$3 = has$7;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$3(hiddenKeys$2, key) && has$3(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$3(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$2;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$4 = anObject$6;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$4(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$2 = has$7;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$7 = fails$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$7(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$2 = global$b;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var redefine$1 = redefine$2.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$2;
  } else if (STATIC) {
    target = global$2[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$2[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$1(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var requireObjectCoercible$4 = requireObjectCoercible$6;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object(requireObjectCoercible$4(argument));
};

var DESCRIPTORS$2 = descriptors;
var fails$6 = fails$b;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$3;
var IndexedObject$1 = indexedObject;

var nativeAssign = Object.assign;
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$6(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && nativeAssign({ b: 1 }, nativeAssign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys$1(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $$5 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$$5({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

const basicColors = {
  black100: '#000000',
  blue10: '#ECF6FD',
  blue20: '#F4FAFE',
  blue30: '#C9E9FF',
  blue90: '#0D8CE6',
  gray10: '#F1F1F1',
  gray20: '#E3E4E6',
  gray50: '#999999',
  gray90: '#525252',
  green90: '#2DC294',
  orange10: '#FFF6E7',
  orange90: '#F5A724',
  purple10: '#F5F6FA',
  purple20: '#F0F2FA',
  purpleGray90: '#A0A2B2',
  red90: '#F04134',
  white100: '#FFFFFF'
};
const primaryColors = {
  gray100: '#F8F8F8',
  gray200: '#ECEEF0',
  gray300: '#D4DADE',
  gray400: '#B8C2CA',
  gray500: '#88949E',
  gray600: '#65747F',
  gray700: '#45525B',
  gray800: '#363F46',
  blue100: '#EDF7FD',
  blue200: '#D6ECFD',
  blue300: '#90CCF9',
  blue400: '#40A7F6',
  blue500: '#158CE6',
  blue600: '#0372C7',
  blue700: '#025492',
  blue800: '#013C68',
  red100: '#FFF0F1',
  red200: '#FECDD2',
  red300: '#EE9A9A',
  red400: '#F47B7B',
  red500: '#EE5350',
  red600: '#D13131',
  red700: '#A72727',
  red800: '#6D1919',
  green100: '#E0F2EC',
  green200: '#B3DECF',
  green300: '#83C9B1',
  green400: '#55B392',
  green500: '#309270',
  green600: '#147652',
  green700: '#0A5C3E',
  green800: '#003C23'
};
const buttonColors = {
  primaryBackground: basicColors.blue90,
  primaryHoverBackground: 'rgba(13, 140, 230, 0.9)',
  // We don't use Color because it's too heavy
  // primaryHoverBackground: Color(WSBasicColors.blue90).alpha(0.9),
  // primaryActiveBackground: Color(WSBasicColors.blue90).darken(0.1),
  // primaryDisabledBackground: Color(WSBasicColors.blue90).alpha(0.35),
  primaryActiveBackground: '#0C7ECF',
  primaryDisabledBackground: 'rgba(13, 140, 230, 0.35)',
  primaryText: basicColors.white100,
  primaryBorder: basicColors.blue90,
  secondaryBackground: basicColors.white100,
  secondaryText: basicColors.gray90,
  secondaryBorder: basicColors.gray20,
  secondaryHoverBackground: '#FBFBFB',
  secondaryHoverBorder: '#CDCDCD',
  secondaryActiveBackground: basicColors.white100,
  secondaryDisabledBackground: basicColors.white100,
  secondaryDisabledText: basicColors.gray50,
  // boxShadow is not a color, use theme.shadow.default instead.
  // boxShadow: 'inset 0px 3px 5px rgba(0, 0, 0, 0.08)',
  defaultShadow: 'rgba(0, 0, 0, 0.08)'
};
const modalColors = {
  modalWindow: 'rgba(13, 31, 43, 0.7)'
};
const legacyColors = Object.assign(Object.assign(Object.assign(Object.assign({}, basicColors), primaryColors), buttonColors), modalColors);
const isColorName = colorStr => !!legacyColors[colorStr];

const theme = {
  legacyColors,
  boxShadow: {
    default: `inset 0px 3px 5px ${legacyColors.defaultShadow}`
  }
};

/**
 * keep string and turn number into css property with unit
 * @param numOrStr
 * @param unitOrFunc
 * @returns
 */
const autoAddUnit = (numOrStr, unitOrFunc = 'px') => {
  if (typeof numOrStr !== 'number') return numOrStr;
  return typeof unitOrFunc === 'function' ? unitOrFunc(numOrStr) : `${numOrStr}${unitOrFunc}`;
};

const GlobalStyle = /*#__PURE__*/createGlobalStyle([".ant-form-item .intl-tel-input{width:100%;}"]);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var classof$2 = classofRaw;

// `thisNumberValue` abstract operation
// https://tc39.github.io/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = function (value) {
  if (typeof value != 'number' && classof$2(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};

var toInteger$3 = toInteger$6;
var requireObjectCoercible$3 = requireObjectCoercible$6;

// `String.prototype.repeat` method implementation
// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
var stringRepeat = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible$3(this));
  var result = '';
  var n = toInteger$3(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$4 = _export;
var toInteger$2 = toInteger$6;
var thisNumberValue = thisNumberValue$1;
var repeat = stringRepeat;
var fails$5 = fails$b;

var nativeToFixed = 1.0.toFixed;
var floor$1 = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails$5(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.github.io/ecma262/#sec-number.prototype.tofixed
$$4({ target: 'Number', proto: true, forced: FORCED }, {
  // eslint-disable-next-line max-statements
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger$2(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    var multiply = function (n, c) {
      var index = -1;
      var c2 = c;
      while (++index < 6) {
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = floor$1(c2 / 1e7);
      }
    };

    var divide = function (n) {
      var index = 6;
      var c = 0;
      while (--index >= 0) {
        c += data[index];
        data[index] = floor$1(c / n);
        c = (c % n) * 1e7;
      }
    };

    var dataToString = function () {
      var index = 6;
      var s = '';
      while (--index >= 0) {
        if (s !== '' || index === 0 || data[index] !== 0) {
          var t = String(data[index]);
          s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
        }
      } return s;
    };

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        result = dataToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        result = dataToString() + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction = aFunction$1;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;
var toLength$1 = toLength$3;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject$1(that);
    var self = IndexedObject(O);
    var length = toLength$1(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$4 = fails$b;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$4(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var DESCRIPTORS$1 = descriptors;
var fails$3 = fails$b;
var has$1 = has$7;

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength$2 = function (METHOD_NAME, options) {
  if (has$1(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has$1(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has$1(options, 0) ? options[0] : thrower;
  var argument1 = has$1(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails$3(function () {
    if (ACCESSORS && !DESCRIPTORS$1) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $$3 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var arrayMethodUsesToLength$1 = arrayMethodUsesToLength$2;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH$1 = arrayMethodUsesToLength$1('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$$3({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

const designPresets = [{
  variant: 'h1',
  component: 'h1',
  fontSize: 34,
  lineHeight: 46
}, {
  variant: 'h2',
  component: 'h2',
  fontSize: 24,
  lineHeight: 32
}, {
  variant: 'h3',
  component: 'h3',
  fontSize: 20,
  lineHeight: 28,
  fontWeight: 'semibold'
}, {
  variant: 'h4',
  component: 'h4',
  fontSize: 18,
  lineHeight: 24,
  fontWeight: 'bold'
}, {
  variant: 'h5',
  component: 'h5',
  fontSize: 16,
  lineHeight: 22,
  fontWeight: 'bold'
}, {
  variant: 'body1',
  component: 'p',
  fontSize: 14,
  lineHeight: 20
}, {
  variant: 'body2',
  component: 'p',
  fontSize: 13,
  lineHeight: 18
}, {
  variant: 'body3',
  component: 'p',
  fontSize: 12,
  lineHeight: 16,
  fontWeight: 'semibold'
}, {
  variant: 'body4',
  component: 'p',
  fontSize: 10,
  lineHeight: 14,
  fontWeight: 'bold'
}];
const presets = designPresets.map(_a => {
  var {
      fontSize,
      lineHeight
    } = _a,
    props = __rest(_a, ["fontSize", "lineHeight"]);
  return Object.assign(Object.assign({}, props), {
    fontSize,
    lineHeight: (lineHeight / fontSize).toFixed(3)
  });
});
const presetPropsByVarant = presets.reduce((res, _a) => {
  var {
      variant,
      component
    } = _a,
    styleProps = __rest(_a, ["variant", "component"]);
  res[variant] = {
    props: {
      component
    },
    styleProps
  };
  return res;
}, {});

/**
 * Build typography style from style props
 */
const buildTypographyStyle = ({
  fontSize,
  fontWeight,
  lineHeight,
  textAlign,
  color,
  ellipsis,
  id,
  maxCh,
  marginTop: _marginTop = 0,
  marginBottom: _marginBottom = 0
}) => css(["font-family:'Segoe UI',Arial,Helvetica,sans-serif;font-size:", ";line-height:", ";font-weight:", ";margin-top:", ";margin-bottom:", ";", " ", " ", " ", " ", ""], autoAddUnit(fontSize) || 'inherit', lineHeight ? autoAddUnit(lineHeight, num => num < 10 ? num : `${num}px`) : 'inherit', fontWeight === 'semibold' ? 600 : fontWeight || 'inherit', autoAddUnit(_marginTop), autoAddUnit(_marginBottom), textAlign && `text-align: ${textAlign};`, ({
  theme
}) => color && `color: ${theme.legacyColors[color] || color};`, ellipsis && css(["display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], ellipsis), id && 'scroll-margin-top: 100px;', maxCh && `max-width: ${maxCh}ch`);
/**
 * Get preset typography style from variant quickly.
 * Also support override props
 */
const getTypographyStyle = (variant = 'body1', overrideProps) => {
  const {
    styleProps
  } = presetPropsByVarant[variant];
  return buildTypographyStyle(Object.assign(Object.assign({}, styleProps), overrideProps));
};
const Typography$1 = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledTypography__Typography",
  componentId: "sc-vkpgd4-0"
})(["", ""], props => getTypographyStyle(props.variant, props));
const S$b = {
  Typography: Typography$1
};

/**
 * Typography
 */
const Typography = _a => {
  var {
      variant = 'body1',
      component
    } = _a,
    restProps = __rest(_a, ["variant", "component"]);
  const as = component || presetPropsByVarant[variant].props.component;
  return jsx(S$b.Typography, Object.assign({
    variant: variant,
    as: as
  }, restProps), void 0);
};

const S$a = {
  MenuItem: styled(Menu$1.Item).withConfig({
    displayName: "Menu__MenuItem",
    componentId: "sc-16gjn2y-0"
  })([".antd2-menu-item-icon{min-width:14px;margin-right:10px;}"]),
  MenuSubMenu: styled(Menu$1.SubMenu).withConfig({
    displayName: "Menu__MenuSubMenu",
    componentId: "sc-16gjn2y-1"
  })(["&.ant-menu-submenu-inline > .ant-menu-submenu-title:after{top:12px;}.antd2-menu-item-icon{min-width:14px;margin-right:10px;}"])
};
const MenuItem$2 = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      icon,
      children
    } = _a,
    rest = __rest(_a, ["icon", "children"]);
  return jsxs(S$a.MenuItem, Object.assign({}, rest, {
    ref: ref
  }, {
    children: [icon && jsx("div", Object.assign({
      className: "antd2-menu-item-icon"
    }, {
      children: icon
    }), void 0), children]
  }), void 0);
});
const MenuSubMenu = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      icon,
      title
    } = _a,
    rest = __rest(_a, ["icon", "title"]);
  return jsx(S$a.MenuSubMenu, Object.assign({}, rest, {
    title: jsxs(Fragment, {
      children: [icon && jsx("div", Object.assign({
        className: "antd2-menu-item-icon"
      }, {
        children: icon
      }), void 0), title]
    }, void 0),
    ref: ref
  }), void 0);
});

if (process.env.NODE_ENV === 'development') {
  console.info('[workstream-ui] Using with antd@v2');
}

const Button$1 = /*#__PURE__*/styled(Button$2).withConfig({
  shouldForwardProp: prop => !includes(['size'], prop)
}).withConfig({
  displayName: "styledButton__Button",
  componentId: "sc-1w7qscl-0"
})(["display:inline-block;align-items:center;border-radius:4px;cursor:pointer;", " font-weight:400;", " ", " &.ant-btn{", ";}.ws-icon{font-size:16px;}& > .ws-icon + span{margin-left:10px;}& > span + .ws-icon{margin-left:10px;}"], getTypographyStyle('body1'), ({
  width
}) => width && css(["width:", ";"], autoAddUnit(width)), ({
  size
}) => size === 'large' ? css(["height:40px;padding:10px 15px;"]) : css(["height:32px;padding:6px 15px;"]), ({
  theme,
  type
}) => {
  const isPrimary = type === 'primary';
  return css(["color:", ";background-color:", ";border:1px solid ", ";&:hover{border:1px solid ", ";background-color:", ";", "}", " &:active,&.active{", " box-shadow:inset 0px 3px 5px rgba(0,0,0,0.13);}&.disabled,&[disabled]{color:", ";background-color:", ";border:1px solid ", ";box-shadow:none;", "}"], theme.legacyColors[isPrimary ? 'white100' : 'gray90'], theme.legacyColors[isPrimary ? 'blue90' : 'white100'], theme.legacyColors[isPrimary ? 'blue90' : 'gray20'], isPrimary ? theme.legacyColors.blue90 : '#cdcdcd', isPrimary ? theme.legacyColors.blue90 : '#fbfbfb', isPrimary && 'opacity: 0.9;', isPrimary && 'box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16109);', isPrimary && 'background-color: #0c7ece;', theme.legacyColors[isPrimary ? 'white100' : 'gray50'], theme.legacyColors[isPrimary ? 'blue90' : 'white100'], theme.legacyColors[isPrimary ? 'blue90' : 'gray20'], isPrimary && 'opacity: 0.35;');
});
const S$9 = {
  Button: Button$1
};

/**
 * Button
 */
const Button = _a => {
  var {
      size
    } = _a,
    restProps = __rest(_a, ["size"]);
  return jsx(S$9.Button, Object.assign({
    size: size
  }, restProps), void 0);
};

const largeCheckBox = /*#__PURE__*/css(["font-size:13px;.ant-checkbox-checked .ant-checkbox-inner:after{transform:rotate(45deg) scale(1.2);top:2px;left:5px;}.ant-checkbox-inner{width:17px;height:17px;}"]);
const Checkbox = /*#__PURE__*/styled(Checkbox$1).withConfig({
  shouldForwardProp: prop => !includes(['size'], prop)
}).withConfig({
  displayName: "styledCheckbox__Checkbox",
  componentId: "sc-1xgw6o3-0"
})(["", ";"], ({
  size
}) => size === 'large' && largeCheckBox);
const CheckboxGroup = /*#__PURE__*/styled(Checkbox$1.Group).withConfig({
  shouldForwardProp: prop => !includes(['size'], prop)
}).withConfig({
  displayName: "styledCheckbox__CheckboxGroup",
  componentId: "sc-1xgw6o3-1"
})(["", ";"], ({
  size
}) => size === 'large' && css([".ant-checkbox-wrapper{font-size:13px;}", ""], largeCheckBox));

var fails$2 = fails$b;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$2(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$1 = global$b;
var shared = shared$2.exports;
var has = has$7;
var uid = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global$1.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol$4 = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var DESCRIPTORS = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var anObject$3 = anObject$6;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$3(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn = getBuiltIn$2;

var html$1 = getBuiltIn('document', 'documentElement');

var anObject$2 = anObject$6;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$2(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$3 = wellKnownSymbol$4;
var create = objectCreate;
var definePropertyModule = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$3('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$2 = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables = addToUnscopables$1;
var arrayMethodUsesToLength = arrayMethodUsesToLength$2;

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$$2({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$5;
var classof$1 = classofRaw;
var wellKnownSymbol$2 = wellKnownSymbol$4;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) == 'RegExp');
};

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$4;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

var $$1 = _export;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var correctIsRegExpLogic = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$$1({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible$2(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

const defaultLoadScriptProps = {
  libraries: ['places']
};
const addressComponentTypeByFormAddressKey = {
  country: 'country',
  state: 'administrative_area_level_1',
  city: 'locality',
  postalCode: 'postal_code',
  streetAddress: 'route',
  streetNumber: 'street_number',
  neighborhood: 'neighborhood'
};
const defaultAddressKeys = ['country', 'state', 'city', 'postalCode', 'streetAddress'];
const buildFormAddressFromGoogleMapPlace = (googleMapPlace, addressKeys = defaultAddressKeys) => {
  var _a;
  const {
    address_components: addressComponents = []
  } = googleMapPlace;
  const googleAddress = mapValues(addressComponentTypeByFormAddressKey, type => {
    var _a;
    return (_a = addressComponents.find(({
      types
    }) => types.includes(type))) === null || _a === void 0 ? void 0 : _a.short_name;
  });
  // https://workstreamhq.atlassian.net/browse/WS-5715
  // If the city is not fulfilled from 'locality', we need to read it from another key
  // This happens if you search '28116 The Old Rd, Valencia, CA, USA' in the
  // google auto complete input. It's rare of not having a city from the google
  // auto complete, but it happens.
  if (googleAddress.city === undefined) {
    googleAddress.city = googleAddress.neighborhood;
  }
  if ((_a = googleAddress.streetNumber) === null || _a === void 0 ? void 0 : _a.length) {
    googleAddress.streetAddress = `${googleAddress.streetNumber} ${googleAddress.streetAddress}`;
  }
  return pick(googleAddress, addressKeys);
};

/**
 * GoogleAddressAutocomplete
 */
const GoogleAddressAutocompleteRenderer = props => {
  const propsRef = useRef(props);
  propsRef.current = props;
  const {
      id,
      onChange,
      onPlaceChanged: propOnPlaceChanged,
      loadScript,
      // We don't have the logic to make this component controlled yet.
      // Just ignore `value` prop here to prevent error.
      value,
      addressKeys
    } = props,
    restProps = __rest(props, ["id", "onChange", "onPlaceChanged", "loadScript", "value", "addressKeys"]);
  const instanceRef = useRef();
  const onLoad = useCallback(instance => {
    instanceRef.current = instance;
  }, []);
  const onPlaceChanged = useCallback(() => {
    var _a, _b, _c, _d, _e;
    const place = (_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.getPlace();
    if (!place) return;
    (_c = (_b = propsRef.current).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, buildFormAddressFromGoogleMapPlace(place, propsRef.current.addressKeys));
    (_e = (_d = propsRef.current).onPlaceChanged) === null || _e === void 0 ? void 0 : _e.call(_d, place);
  }, []);
  return jsx(Autocomplete, Object.assign({
    className: "ant-input-affix-wrapper",
    onLoad: onLoad,
    onPlaceChanged: onPlaceChanged
  }, restProps, {
    children: jsx("input", {
      id: id,
      className: "ant-input"
    }, void 0)
  }), void 0);
};
/**
 * GoogleAddressAutocomplete
 */
const GoogleAddressAutocompleteLoadScript = _a => {
  var {
      // When google is defined, skip load script by default
      loadScript,
      value
    } = _a,
    restProps = __rest(_a, ["loadScript", "value"]);
  const apiKey = loadScript && (loadScript === null || loadScript === void 0 ? void 0 : loadScript.googleMapsApiKey) || process.env['GOOGLE_MAPS_API_KEY'] || process.env['NX_GOOGLE_MAPS_API_KEY'] || '';
  const {
    isLoaded
  } = useJsApiLoader(Object.assign(Object.assign({}, defaultLoadScriptProps), {
    id: 'google-map-script',
    googleMapsApiKey: apiKey
  }));
  if (!apiKey) {
    throw new Error('[GoogleAddressAutocomplete]: props.loadScript.googleMapsApiKey, process.env.GOOGLE_MAPS_API_KEY or process.env.NX_GOOGLE_MAPS_API_KEY must be provided');
  }
  if (!isLoaded) {
    return jsx("div", Object.assign({
      className: "ant-input-affix-wrapper"
    }, {
      children: jsx("input", {
        className: "ant-input",
        placeholder: "Google maps loading"
      }, void 0)
    }), void 0);
  }
  return jsx(GoogleAddressAutocompleteRenderer, Object.assign({}, restProps), void 0);
};
/**
 * GoogleAddressAutocomplete
 */
const GoogleAddressAutocomplete = _a => {
  var {
      // When google is defined, skip load script by default
      loadScript = typeof google !== 'undefined' ? false : undefined,
      value
    } = _a,
    restProps = __rest(_a, ["loadScript", "value"]);
  if (loadScript === false) {
    if (typeof google === 'undefined') {
      console.error('[GoogleAddressAutocomplete]: loadScript is false but google is undefined, you should either load google globally to enable loadScript');
      return jsx("div", Object.assign({
        className: "ant-input-affix-wrapper"
      }, {
        children: jsx("input", {
          className: "ant-input",
          placeholder: "Google maps not loaded"
        }, void 0)
      }), void 0);
    }
    return jsx(GoogleAddressAutocompleteRenderer, Object.assign({}, restProps), void 0);
  }
  return jsx(GoogleAddressAutocompleteLoadScript, Object.assign({
    loadScript: loadScript
  }, restProps), void 0);
};

/**
 * ConditionalWrapper
 */
const ConditionalWrapper = ({
  children,
  condition,
  wrapper
}) => {
  if (!condition) return children;
  return /*#__PURE__*/React.createElement(wrapper, {}, children);
};

const Square = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: prop => !includes(['size'], prop)
}).withConfig({
  displayName: "styledSquare__Square",
  componentId: "sc-5my3ba-0"
})(["", " display:inline-flex;align-items:center;justify-content:center;"], ({
  size: _size = 14
}) => css(["width:", ";height:", ";"], autoAddUnit(_size), autoAddUnit(_size)));

/**
 * Icon
 */
const Icon$1 = /*#__PURE__*/styled.span.withConfig({
  shouldForwardProp: prop => !includes(['color'], prop)
}).withConfig({
  displayName: "styledIcon__Icon",
  componentId: "sc-1qv7g67-0"
})(["&&{flex-shrink:0;", "}"], ({
  size,
  color,
  theme,
  onClick
}) => css(["font-size:", ";&:before{color:", ";}", ""], size ? autoAddUnit(size) : '100%', isColorName(color) ? theme.legacyColors[color] : color || 'inherit', onClick && 'cursor: pointer;'));
const S$8 = {
  Icon: Icon$1
};

const WS_ICON_PREFIX = 'ws-icon';
/**
 * Icon
 *
 */
const Icon = _a => {
  var {
      type,
      className,
      wrapperSize
    } = _a,
    restProps = __rest(_a, ["type", "className", "wrapperSize"]);
  return jsx(ConditionalWrapper, Object.assign({
    condition: !!wrapperSize,
    wrapper: props => jsx(Square, Object.assign({
      className: className,
      size: wrapperSize
    }, props), void 0)
  }, {
    children: jsx(S$8.Icon, Object.assign({
      className: classNames(WS_ICON_PREFIX, `${WS_ICON_PREFIX}-${type}`, wrapperSize ? '' : className)
    }, restProps), void 0)
  }), void 0);
};

var anObject$1 = anObject$6;

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$1 = fails$b;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

regexpStickyHelpers.UNSUPPORTED_Y = fails$1(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$1(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $ = _export;
var exec = regexpExec$2;

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine = redefine$2.exports;
var fails = fails$b;
var wellKnownSymbol = wellKnownSymbol$4;
var regexpExec$1 = regexpExec$2;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec$1) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};

var toInteger$1 = toInteger$6;
var requireObjectCoercible$1 = requireObjectCoercible$6;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$1($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var classof = classofRaw;
var regexpExec = regexpExec$2;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$6;
var toObject = toObject$3;
var toLength = toLength$3;
var toInteger = toInteger$6;
var requireObjectCoercible = requireObjectCoercible$6;
var advanceStringIndex = advanceStringIndex$1;
var regExpExec = regexpExecAbstract;

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

const StyledIntlTelInput = _a => {
  var {
      className,
      containerClassName,
      inputClassName
    } = _a,
    props = __rest(_a, ["className", "containerClassName", "inputClassName"]);
  return jsx(ReactIntlTelInput, Object.assign({}, props, {
    containerClassName: classNames('intl-tel-input', className, containerClassName),
    inputClassName: classNames('ant-input', inputClassName)
  }), void 0);
};
const S$7 = {
  IntlTelInput: StyledIntlTelInput
};

const newSgNumberRegex = /[8|9]\d{7}|\+65[8|9]\d{7}|\+65\s[8|9]\d{7}/;
const recalculateValueValidAndFormat = intlTelValue => {
  return Object.assign(Object.assign({}, intlTelValue), {
    value: intlTelValue.value.replace(/[^0-9]/g, ''),
    isValid: intlTelValue.isValid || newSgNumberRegex.test(intlTelValue.value)
  });
};

/**
 * IntlTelInput
 */
const IntlTelInput = _a => {
  var _b, _c;
  var {
      className,
      value,
      onChange,
      onPhoneNumberChange,
      onPhoneNumberBlur,
      defaultValue
    } = _a,
    otherProps = __rest(_a, ["className", "value", "onChange", "onPhoneNumberChange", "onPhoneNumberBlur", "defaultValue"]);
  const found = country.findByPhoneNbr(`${defaultValue}`);
  return jsx(S$7.IntlTelInput, Object.assign({
    format: false,
    defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.replace(`+${found === null || found === void 0 ? void 0 : found.dialing_code}`, ''),
    defaultCountry: ((_b = found === null || found === void 0 ? void 0 : found.code) === null || _b === void 0 ? void 0 : _b.iso2.toLowerCase()) || ((_c = value === null || value === void 0 ? void 0 : value.countryData) === null || _c === void 0 ? void 0 : _c.iso2) || 'us',
    preferredCountries: ['us', 'sg', 'ca']
  }, otherProps, {
    value: value === null || value === void 0 ? void 0 : value.value,
    onPhoneNumberChange: (isValid, value, countryData, fullNumber, extension) => {
      const newValue = recalculateValueValidAndFormat({
        isValid,
        value,
        countryData,
        fullNumber,
        extension
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
      onPhoneNumberChange === null || onPhoneNumberChange === void 0 ? void 0 : onPhoneNumberChange(newValue.isValid, newValue.value, countryData, fullNumber, extension);
    },
    onPhoneNumberBlur: (isValid, value, countryData, fullNumber, extension, event) => {
      const newValue = recalculateValueValidAndFormat({
        isValid,
        value,
        countryData,
        fullNumber,
        extension
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
      onPhoneNumberBlur === null || onPhoneNumberBlur === void 0 ? void 0 : onPhoneNumberBlur(newValue.isValid, newValue.value, countryData, fullNumber, extension, event);
    }
  }), void 0);
};

const Item = Menu$1.Item;
const MenuItem$1 = /*#__PURE__*/styled(Item).withConfig({
  displayName: "styledMenu__MenuItem",
  componentId: "sc-qb2mhw-0"
})(["height:32px;font-size:12px;font-weight:400;color:#525252;padding:8px 10px 8px 10px;line-height:16px;", ""], ({
  theme
}) => {
  return css(["&:hover{background-color:", ";}"], theme.legacyColors.blue10);
});
const S$6 = {
  MenuItem: MenuItem$1
};

const MenuItem = _a => {
  var {
      className
    } = _a,
    restProps = __rest(_a, ["className"]);
  return jsx(S$6.MenuItem
  // @ts-ignore
  , Object.assign({
    // @ts-ignore
    theme: theme,
    className: `${className} ws-menu-item`
  }, restProps), void 0);
};
const Menu = _a => {
  var {
      className
    } = _a,
    restProps = __rest(_a, ["className"]);
  return jsx(Menu$1, Object.assign({
    className: `${className} ws-menu`
  }, restProps), void 0);
};
Menu.Item = MenuItem;
Menu.SubMenu = Menu$1.SubMenu;
Menu.ItemGroup = Menu$1.ItemGroup;
Menu.Divider = Menu$1.Divider;

var img$1 = "data:image/svg+xml,%3csvg width='25' height='25' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M25 0H0c13.807 0 25 11.193 25 25V0Z' fill='white'/%3e%3c/svg%3e";

const MenuBar$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledMenuBar__MenuBar",
  componentId: "sc-1qucp93-0"
})(["height:100%;max-height:100%;width:73px;background:linear-gradient(180deg,#3460e3 0%,#2aa5ee 100%);color:white;display:flex;flex-direction:column;.MenuBar-logo{width:39px;height:39px;margin:24px 17px 12px;}.MenuBar-main{flex:1;}.MenuBar-footer{padding-bottom:10px;}"]);
const SideBarItem$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledMenuBar__SideBarItem",
  componentId: "sc-1qucp93-1"
})(["display:flex;flex-direction:column;justify-content:center;position:relative;a{color:inherit;text-decoration:none;}.MenuBar-item-wrapper{padding-top:12px;padding-bottom:12px;", " display:flex;flex-direction:column;align-items:center;}.SiderBar-item-desc{margin-top:4px;}", ""], ({
  name,
  icon
}) => name && icon && css(["@media (max-height:799px){padding-top:7px;padding-bottom:7px;}"]), ({
  selected,
  theme
}) => selected && css(["background-color:white;color:", ";:before,:after{content:'';position:absolute;width:25px;height:25px;right:0;background-color:transparent;background-image:url(", ");}:after{bottom:-25px;}:before{top:-25px;transform:scaleY(-1);}"], theme.legacyColors.blue90, img$1));
const S$5 = {
  MenuBar: MenuBar$1,
  SideBarItem: SideBarItem$1
};

var img = "data:image/svg+xml,%3csvg width='34' height='34' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill-rule='nonzero' fill='none'%3e%3crect fill='%23457CFF' width='34' height='34' rx='2.4'/%3e%3cpath d='m9.209 15.362-.453.405-.81-.905.453-.405c.024-.021.067-.06.128-.112a18.772 18.772 0 0 1 1.477-1.148 12.1 12.1 0 0 1 1.153-.72c.714-.386 1.344-.603 1.897-.603 1.562 0 2.41.408 3.601 1.448l.25.218c1.148.998 1.984 1.37 3.738 1.37 1.447 0 2.815-.639 4.124-1.948l.43-.43.858.86-.43.429c-1.524 1.524-3.192 2.303-4.982 2.303-2.077 0-3.181-.491-4.534-1.667l-.252-.22c-.99-.864-1.582-1.149-2.803-1.149-.307 0-.767.159-1.32.458-.326.176-.674.395-1.035.647a17.576 17.576 0 0 0-1.49 1.169ZM9.209 21.433l-.453.405-.81-.904.453-.405.128-.113a18.772 18.772 0 0 1 1.477-1.148 12.1 12.1 0 0 1 1.153-.72c.714-.386 1.344-.603 1.897-.603 1.562 0 2.41.409 3.601 1.448l.25.219c1.148.997 1.984 1.369 3.738 1.369 1.447 0 2.815-.639 4.124-1.947l.43-.43.858.859-.43.43c-1.524 1.524-3.192 2.302-4.982 2.302-2.077 0-3.181-.49-4.534-1.667l-.252-.22c-.99-.864-1.582-1.149-2.803-1.149-.307 0-.767.16-1.32.458-.326.176-.674.396-1.035.647a17.576 17.576 0 0 0-1.49 1.17Z' fill='white'/%3e%3c/g%3e%3c/svg%3e";

/**
 * default renderItem, render a simple anchor element directly
 * @param node
 * @param item
 * @returns
 */
const defaultRenderItem = (node, item) => {
  if (!item.href) return node;
  return jsx("a", Object.assign({
    href: item.href
  }, {
    children: node
  }), void 0);
};
/**
 * type guard for icon
 * @param icon
 * @returns
 */
const isIconType$1 = icon => typeof icon === 'string';

const SideBarItem = ({
  name,
  icon,
  href,
  renderItem: _renderItem = defaultRenderItem,
  selected,
  className
}) => {
  const item = {
    name,
    icon,
    href
  };
  return jsx(S$5.SideBarItem, Object.assign({
    className: classNames('MenuBar-item', className),
    selected: selected,
    name: name,
    icon: icon
  }, {
    children: _renderItem(jsxs("div", Object.assign({
      className: "MenuBar-item-wrapper"
    }, {
      children: [isIconType$1(icon) ? jsx(Icon, {
        type: icon,
        size: 20
      }, void 0) : icon, name && jsx(Typography, Object.assign({
        variant: "body4",
        className: "SiderBar-item-desc"
      }, {
        children: name
      }), void 0)]
    }), void 0), item)
  }), void 0);
};
/**
 * MenuBar
 */
const MenuBar = ({
  logo: _logo = img,
  selectedKey,
  items,
  renderItem: _renderItem2 = defaultRenderItem,
  footer,
  className
}) => {
  return jsxs(S$5.MenuBar, Object.assign({
    className: classNames('MenuBar', className)
  }, {
    children: [jsx("img", {
      className: "MenuBar-logo",
      src: _logo,
      alt: "logo"
    }, void 0), jsx("div", Object.assign({
      className: "MenuBar-main"
    }, {
      children: items.map((item, index) => /*#__PURE__*/createElement$1(SideBarItem, Object.assign({}, item, {
        selected: selectedKey === item.key,
        key: item.key,
        renderItem: node => _renderItem2(node, item, index)
      })))
    }), void 0), footer && jsx("div", Object.assign({
      className: "MenuBar-footer"
    }, {
      children: footer
    }), void 0)]
  }), void 0);
};

const Select$1 = /*#__PURE__*/styled(Select$2).withConfig({
  displayName: "styledSelect__Select",
  componentId: "sc-18zvapg-0"
})(["", ";"], ({
  theme
}) => {
  return css(["&.ant-select{color:", ";.ant-select-selector{border-color:", ";border-radius:4px;}.ant-select-arrow{color:", ";}&.ant-select-single{&.ant-select-open{.ant-select-selection-item{color:", ";}}}&:not(.ant-select-disabled){&.ant-select-focused:not(.ant-select-customize-input){.ant-select-selector,.ant-select-selection{border-radius:4px;border-color:", ";box-shadow:inset 0px 3px 5px rgba(0,0,0,0.08);}}&:hover{.ant-select-selector,.ant-select-selection{border-color:", ";}}}}"], theme.legacyColors.gray90, theme.legacyColors.gray20, theme.legacyColors.gray90, theme.legacyColors.gray90, theme.legacyColors.gray20, theme.legacyColors.gray20);
});
Select$1.Option = Select$2.Option;
Select$1.OptGroup = Select$2.OptGroup;
const S$4 = {
  Select: Select$1
};

const Select = S$4.Select;

const SvgIcon$1 = /*#__PURE__*/styled.svg.withConfig({
  displayName: "styledSvgIcon__SvgIcon",
  componentId: "sc-1ogttb9-0"
})(["flex-shrink:0;", ""], ({
  size,
  color,
  fill,
  theme,
  onClick
}) => css(["width:", ";height:", ";color:", ";fill:", ";", ""], autoAddUnit(size || 24), autoAddUnit(size || 24), isColorName(color) ? theme.legacyColors[color] : color || 'inherit', isColorName(fill) ? theme.legacyColors[fill] : fill || 'currentColor', onClick && 'cursor: pointer;'));
const S$3 = {
  SvgIcon: SvgIcon$1
};

/**
 * SvgIcon
 */
const SvgIcon = _a => {
  var {
      className,
      children,
      wrapperSize
    } = _a,
    props = __rest(_a, ["className", "children", "wrapperSize"]);
  return jsx(ConditionalWrapper, Object.assign({
    condition: !!wrapperSize,
    wrapper: props => jsx(Square, Object.assign({
      size: wrapperSize,
      className: className
    }, props), void 0)
  }, {
    children: jsx(S$3.SvgIcon, Object.assign({
      className: classNames('SvgIcon', wrapperSize ? '' : className),
      viewBox: "0 0 24 24"
    }, props, {
      children: children
    }), void 0)
  }), void 0);
};
/**
 * convinient helper to create simple svg icons
 * @param path
 * @param displayName
 * @param defaultProps
 * @returns
 */
const createSvgIcon = (path, displayName, defaultProps) => {
  const Component = props => jsx(SvgIcon, Object.assign({}, defaultProps, props, {
    children: path
  }), void 0);
  Component.displayName = displayName;
  return Component;
};

const Reward = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "M1.16 19.227c0 .428.345.773.772.773h6.909v-9.082H1.159v8.31Zm9.323.773h6.908a.772.772 0 0 0 .773-.773v-8.31h-7.68V20Zm8.068-14.88h-3.565c.328-.516.521-1.13.521-1.787A3.337 3.337 0 0 0 12.174 0c-1 0-1.901.444-2.512 1.145A3.33 3.33 0 0 0 7.15 0a3.337 3.337 0 0 0-3.334 3.333c0 .657.191 1.27.522 1.788H.773A.772.772 0 0 0 0 5.894v3.381h8.84V5.121h1.643v4.154h8.84V5.894a.772.772 0 0 0-.772-.773Zm-9.71-.096H7.15c-.933 0-1.691-.758-1.691-1.69 0-.933.758-1.691 1.69-1.691.933 0 1.692.758 1.692 1.69v1.691Zm3.333 0h-1.69v-1.69c0-.933.758-1.691 1.69-1.691.932 0 1.69.758 1.69 1.69 0 .933-.758 1.691-1.69 1.691Z",
    fill: "url(#a)",
    transform: "translate(2 2)"
  }, void 0), jsx("defs", {
    children: jsxs("linearGradient", Object.assign({
      id: "a",
      x1: "9.662",
      y1: "0",
      x2: "9.662",
      y2: "20",
      gradientUnits: "userSpaceOnUse"
    }, {
      children: [jsx("stop", {
        stopColor: "#FFD53F"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#F39F1F"
      }, void 0)]
    }), void 0)
  }, void 0)]
}, void 0), 'Reward');

const Fire = createSvgIcon(jsx("path", {
  transform: "translate(5 3)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.184 17.474c-.944-.558-1.618-1.54-1.657-2.696-.058-2.157 1.445-3.216 2.33-4.661 1.272-2.08.925-3.37.925-3.37s1.06.597 1.676 2.812c.192.654.23 1.31.173 1.925-.096 1.56-.77 2.966-.77 2.966s1.174-.25 1.502-2.388c.539.559 1.04 1.368 1.098 2.215.096 1.464-.77 2.812-2.08 3.39 2.272-.52 3.89-2.446 4.448-3.852.713-1.772.52-3.351.405-4.719-.154-1.868.5-3.255.5-3.255s-1.251.366-2.176 1.888c-.423.693-.597 1.714-.597 1.714s.097-.905-.5-2.562c-.597-1.617-1.137-2.195-1.464-3.39-.424-1.598.52-3.158.52-3.158s-3.736.694-5.431 3.948C2.584 7.171 3.2 8.904 3.2 8.904s-.636-.597-.963-1.425c-.328-.829-.25-1.58-.25-1.58S-.671 8.827.618 12.505c.867 2.58 2.542 4.276 4.565 4.97Z"
}, void 0), 'Fire', {
  color: '#F04134'
});

const Morning = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.928 12.55a4.344 4.344 0 0 1 7.416 3.072.4.4 0 0 1-.8 0 3.545 3.545 0 1 0-7.088 0 .4.4 0 0 1-.8 0c0-1.152.457-2.257 1.272-3.072ZM12 2.6c.221 0 .4.18.4.4v5.522a.4.4 0 0 1-.8 0V3c0-.22.18-.4.4-.4ZM5.58 9.202a.4.4 0 0 1 .565 0l1.12 1.12a.4.4 0 0 1-.565.566l-1.12-1.12a.4.4 0 0 1 0-.566ZM2.922 15.622c0-.22.18-.4.4-.4H4.9a.4.4 0 0 1 0 .8H3.322a.4.4 0 0 1-.4-.4ZM18.7 15.622a.4.4 0 0 1 .4-.4h1.578a.4.4 0 0 1 0 .8H19.1a.4.4 0 0 1-.4-.4ZM18.42 9.202a.4.4 0 0 1 0 .566l-1.12 1.12a.4.4 0 0 1-.565-.566l1.12-1.12a.4.4 0 0 1 .566 0ZM2.922 18.778c0-.221.18-.4.4-.4h17.356a.4.4 0 0 1 0 .8H3.322a.4.4 0 0 1-.4-.4Z"
  }, void 0), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.717 2.717a.4.4 0 0 1 .566 0l3.155 3.156a.4.4 0 0 1-.565.565L12 3.566 9.127 6.438a.4.4 0 1 1-.565-.565l3.155-3.156Z"
  }, void 0)]
}, void 0), 'Morning', {
  color: 'gray90'
});

const Afternoon = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 8.31a3.69 3.69 0 1 0 0 7.38 3.69 3.69 0 0 0 0-7.38ZM7.509 12a4.49 4.49 0 1 1 8.982 0 4.49 4.49 0 0 1-8.982 0ZM12 2.6c.221 0 .4.18.4.4v1.636a.4.4 0 0 1-.8 0V3c0-.22.18-.4.4-.4ZM12 18.964c.221 0 .4.179.4.4V21a.4.4 0 0 1-.8 0v-1.636c0-.221.18-.4.4-.4ZM5.352 5.352a.4.4 0 0 1 .565 0L7.08 6.513a.4.4 0 0 1-.566.566L5.352 5.917a.4.4 0 0 1 0-.565ZM16.92 16.92a.4.4 0 0 1 .567 0l1.161 1.163a.4.4 0 0 1-.565.565l-1.162-1.162a.4.4 0 0 1 0-.565ZM2.6 12c0-.22.18-.4.4-.4h1.636a.4.4 0 0 1 0 .8H3a.4.4 0 0 1-.4-.4ZM18.964 12c0-.22.179-.4.4-.4H21a.4.4 0 0 1 0 .8h-1.636a.4.4 0 0 1-.4-.4ZM7.079 16.92a.4.4 0 0 1 0 .566l-1.162 1.162a.4.4 0 0 1-.565-.565l1.161-1.162a.4.4 0 0 1 .566 0ZM18.648 5.352a.4.4 0 0 1 0 .565L17.487 7.08a.4.4 0 0 1-.566-.566l1.162-1.161a.4.4 0 0 1 .565 0Z"
}, void 0), 'Afternoon', {
  color: 'gray90'
});

const Evening = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.535 13.935A4.9 4.9 0 0 1 16.9 17.4a.4.4 0 0 1-.8 0 4.1 4.1 0 0 0-8.2 0 .4.4 0 0 1-.8 0 4.9 4.9 0 0 1 1.435-3.465ZM12 9.7a.4.4 0 0 1-.4-.4V3a.4.4 0 0 1 .8 0v6.3a.4.4 0 0 1-.4.4ZM1.7 21c0-.22.179-.4.4-.4h19.8a.4.4 0 1 1 0 .8H2.1a.4.4 0 0 1-.4-.4Z"
  }, void 0), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.283 9.583a.4.4 0 0 1-.566 0l-3.6-3.6a.4.4 0 0 1 .566-.566L12 8.734l3.317-3.317a.4.4 0 1 1 .566.566l-3.6 3.6Z"
  }, void 0)]
}, void 0), 'Evening', {
  color: 'gray90'
});

const TreeSelect$1 = /*#__PURE__*/styled(TreeSelect$2).withConfig({
  displayName: "styledTreeSelect__TreeSelect",
  componentId: "sc-9kub8v-0"
})(["", ";"], ({
  theme
}) => {
  return css(["&.ant-select{color:", ";.ant-select-selector{border-color:", ";border-radius:4px;}.ant-select-arrow{color:", ";}&:not(.ant-select-disabled){&.ant-select-focused:not(.ant-select-customize-input){.ant-select-selector,.ant-select-selection{border-radius:4px;border-color:", ";box-shadow:inset 0px 3px 5px rgba(0,0,0,0.08);}}&:hover{.ant-select-selector,.ant-select-selection{border-color:", ";}}}}"], theme.legacyColors.gray90, theme.legacyColors.gray20, theme.legacyColors.gray90, theme.legacyColors.gray20, theme.legacyColors.gray20);
});
const S$2 = {
  TreeSelect: TreeSelect$1
};

const TreeSelect = S$2.TreeSelect;

const SideMenu = /*#__PURE__*/styled(Menu$1).attrs({
  mode: 'inline'
}).withConfig({
  displayName: "styledSideMenu__SideMenu",
  componentId: "sc-chnkpu-0"
})(["max-width:232px;border:0;&.ant-menu-vertical,&.ant-menu-inline{.ant-menu-item,.ant-menu-submenu-title{", ";font-weight:400;color:", ";margin-bottom:0;display:flex;align-items:center;}}.ant-menu-sub.ant-menu-inline{background:unset;}.ant-menu-item-selected{box-shadow:inset -2px 0px 0px #0d8ce6;}.ant-menu-item-icon{transform:translateY(-2px);}"], getTypographyStyle('body3'), ({
  theme
}) => theme.legacyColors.gray90);
const SideMenuTitle = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: prop => includes(['children', 'className'], prop)
}).withConfig({
  displayName: "styledSideMenu__SideMenuTitle",
  componentId: "sc-chnkpu-1"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;", ""], ({
  borderBottom,
  indent: _indent = 16,
  size: _size = 'normal',
  theme,
  typographyVariant: _typographyVariant = 'h5'
}) => css(["color:", ";height:", "px;padding-left:", ";padding-right:", ";", " ", ""], theme.legacyColors.gray90, _size === 'large' ? 64 : 40, autoAddUnit(_indent), autoAddUnit(_indent), borderBottom !== false && 'box-shadow: inset 0px -1px 0px #f5f6fa;', getTypographyStyle(_typographyVariant, {
  fontWeight: 600
})));
const SideMenuItem = MenuItem$2 || Menu$1.Item;
const SideMenuSubMenu = MenuSubMenu || Menu$1.SubMenu;

const ProgressBar$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledProgressBar__ProgressBar",
  componentId: "sc-1acd3g7-0"
})(["display:flex;width:100%;"]);
const ProgressItem$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledProgressBar__ProgressItem",
  componentId: "sc-1acd3g7-1"
})(["", ""], ({
  theme
}) => {
  return css(["flex:1;color:", ";margin-right:10px;display:inline-block;overflow:hidden;.line{width:100%;&:after{content:'';width:100%;height:5px;border-radius:3px;display:inline-block;background-color:", ";}}.title{font-weight:400;font-size:12px;font-family:'Segoe UI';line-height:16px;.icon-container{padding-right:3px;vertical-align:text-top;}}&.item-finish{color:", ";.line{&:after{background-color:", ";}}}&.item-active{color:", ";.line{&:after{background-color:", ";}}}&.item-attention{color:", ";.line{&:after{background-color:", ";}}}&.item-wait{color:", ";.line{&:after{background-color:", ";}}}&.item-error{color:", ";.line{&:after{background-color:", ";}}}&.item-disabled{opacity:0.35;}"], theme.legacyColors ? theme.legacyColors.gray50 : '', theme.legacyColors.gray10, theme.legacyColors.green90, theme.legacyColors.green90, theme.legacyColors.blue90, theme.legacyColors.blue90, theme.legacyColors.orange90, theme.legacyColors.orange90, theme.legacyColors.gray50, theme.legacyColors.gray10, theme.legacyColors.red90, theme.legacyColors.red90);
});
const S$1 = {
  ProgressBar: ProgressBar$1,
  ProgressItem: ProgressItem$1
};

/**
 * ProgressBar
 */
const isIconType = icon => typeof icon === 'string';
const ProgressBar = props => {
  const {
    children,
    current = 0,
    initial = 0,
    onChange
  } = props;
  const onChangeStep = changedStep => {
    if (onChange && current !== changedStep) {
      onChange(changedStep);
    }
  };
  return jsx(S$1.ProgressBar, {
    children: toArray(children).map((child, index) => {
      const stepNumber = initial + index;
      const childProps = Object.assign({
        active: stepNumber === current,
        key: index,
        stepNumber,
        onStepClick: onChange && onChangeStep
      }, child.props);
      if (!child.props.status) {
        if (stepNumber === current) {
          childProps.status = 'active';
        } else if (stepNumber < current) {
          childProps.status = 'finish';
        } else {
          childProps.status = 'wait';
        }
      }
      return /*#__PURE__*/cloneElement(child, childProps);
    })
  }, void 0);
};
const ProgressItem = props => {
  const {
    title,
    status,
    icon,
    active,
    disabled = false,
    onStepClick,
    stepNumber = 0
  } = props;
  const classnames = classNames('progress-item', `item-${status}`, {
    'item-active': active,
    'item-disabled': disabled
  });
  let IconNode = icon;
  if (!IconNode) {
    if (status === 'finish') {
      IconNode = jsx(Icon, {
        type: "checkmark"
      }, void 0);
    }
  } else if (isIconType(icon)) {
    IconNode = jsx(Icon, {
      type: icon
    }, void 0);
  } else {
    IconNode = icon;
  }
  return jsx(S$1.ProgressItem, Object.assign({
    className: classnames,
    onClick: () => {
      if (!disabled) {
        onStepClick && onStepClick(stepNumber);
      }
    }
  }, {
    children: jsxs("div", {
      children: [jsx("div", {
        className: "line"
      }, void 0), jsxs("div", Object.assign({
        className: "title"
      }, {
        children: [jsx("span", Object.assign({
          className: "icon-container"
        }, {
          children: IconNode
        }), void 0), title]
      }), void 0)]
    }, void 0)
  }), void 0);
};

const RectangleSpace$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledRectangleSpace__RectangleSpace",
  componentId: "sc-ktmx0x-0"
})(["", ""], ({
  width,
  height,
  display
}) => {
  const defaultSize = typeof width === 'undefined' && typeof height === 'undefined' ? 20 : '100%';
  const defaultDisplay = typeof width !== 'undefined' && typeof height === 'undefined' ? 'inline-block' : 'block';
  return css(["display:", ";width:", ";height:", ";vertical-align:bottom;"], display || defaultDisplay, autoAddUnit(width || defaultSize), autoAddUnit(height || defaultSize));
});
const S = {
  RectangleSpace: RectangleSpace$1
};

/**
 * RectangleSpace
 */
const RectangleSpace = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(S.RectangleSpace, Object.assign({
    className: classNames('RectangleSpace', className)
  }, props), void 0);
};

export { Afternoon, Button, Checkbox, CheckboxGroup, ConditionalWrapper, Evening, Fire, GlobalStyle, GoogleAddressAutocomplete, Icon, IntlTelInput, Menu, MenuBar, Morning, ProgressBar, ProgressItem, RectangleSpace, Reward, Select, SideBarItem, SideMenu, SideMenuItem, SideMenuSubMenu, SideMenuTitle, Square, SvgIcon, TreeSelect, Typography, autoAddUnit, createSvgIcon, getTypographyStyle, isColorName, theme };
